import React, { useState } from 'react'

import { Collapse } from '@mantine/core'

import StyledAlert from 'src/components/Feedback/StyledAlert/StyledAlert'

import ApplicationCardFooter from './ApplicationCardFooter'
import ApplicationCardHeader from './ApplicationCardHeader'

interface ApplicationCardProps {
  title: string
  // Optional DOM id on the card root, used as a scroll anchor (e.g. the AI
  // Flags pill scrolls to the Accidents card via ACCIDENTS_CARD_ANCHOR_ID).
  id?: string
  titleExtra?: React.ReactNode
  canAdd?: boolean
  editing?: boolean
  setEditing?: any
  handleSave?: any
  handleCancel?: any
  handleAdd?: any
  children: any
  isSaveDisabled?: boolean
  readonly?: boolean
  isEmpty?: boolean
  showAlert?: boolean
}

const ApplicationCard = ({
  title,
  id,
  titleExtra,
  canAdd = true,
  isEmpty = false,
  isSaveDisabled = false,
  readonly = false,
  editing = false,
  showAlert = isEmpty,
  setEditing,
  handleSave,
  handleCancel,
  handleAdd,
  children,
}: ApplicationCardProps) => {
  const [opened, setOpened] = useState(!isEmpty)

  return (
    <div
      id={id}
      className={`flex w-full flex-col gap-2 rounded-lg border border-doubleNickel-gray-200 p-3`}
    >
      <ApplicationCardHeader
        title={title}
        titleExtra={titleExtra}
        opened={opened}
        setOpened={setOpened}
        canAdd={canAdd}
        isEmpty={isEmpty}
        readonly={readonly}
        editing={editing}
        setEditing={setEditing}
        handleAdd={handleAdd}
      />

      <Collapse in={opened} transitionDuration={400}>
        <div className="flex flex-col gap-4">
          {showAlert ? (
            <StyledAlert
              title={`No ${title.toLowerCase()} found`}
              description="Add a new item to get started"
            />
          ) : (
            <div className="px-4">{children}</div>
          )}
          {editing && (
            <ApplicationCardFooter
              handleSave={handleSave}
              handleCancel={handleCancel}
              isSaveDisabled={isSaveDisabled}
            />
          )}
        </div>
      </Collapse>
    </div>
  )
}

export default ApplicationCard
